/** Milliseconds shown in the largest unit that keeps the number small: `34 s`, `4.5 min`, `1.2 h` (the staff first response runs from seconds to hours). */
const MS_PER_SECOND = 1000;
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;
const TENTH = 10;

type Translate = (key: string, options?: Record<string, unknown>) => string;

const tenths = (value: number): number => Math.round(value * TENTH) / TENTH;

export function staffDurationText(ms: number, t: Translate): string {
  const seconds = ms / MS_PER_SECOND;
  if (seconds < SECONDS_PER_MINUTE) return t("agentReports.kpi.seconds", { value: Math.round(seconds) });
  const minutes = seconds / SECONDS_PER_MINUTE;
  if (minutes < MINUTES_PER_HOUR) return t("agentReports.kpi.minutes", { value: tenths(minutes) });
  return t("agentReports.kpi.hours", { value: tenths(minutes / MINUTES_PER_HOUR) });
}
